import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Storage } from "../../storage";
import { addRecentSearch } from "../../apis/search";


export function usePostRecentSearch() {
  const queryClient = useQueryClient();
  const accessToken = Storage.getCurrentUserToken();
  return useMutation({
    mutationFn: (search: {
        searchTerm: string;
        types: string;
        accessibilities: string;
        showVenueOptions: string;
        openingHoursDay: string;
        openingHoursStartTime: string;
        openingHoursEndTime: string;
        // New geocoding parameters
        latitude?: string;
        longitude?: string;
        address?: string;
        // New search context parameters
        search_type?: string;
        search_value?: string;
        tagging_mode?: string;
        placesToReplaceString?: string;
      }) => addRecentSearch(search, accessToken || ""),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["recentSearches"],
        exact: false,
      });
    },
  });
}